import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import mid from './assets/middle.jpg'
import add from './assets/add.jpg'
import qus from './assets/Qus.png'
import ka from './assets/ka.jpg'
import knap from './assets/knap.png'
import ioa from './assets/ioa.jpg'
import c1na from './assets/c1na.jpg'
import stkMin from './assets/stkMin.png'
import lvbt from './assets/lvbt.png'
import cnsl from './assets/cnsl.png'
import Dependency from './assets/Dependencygraph.png'
import msz from './assets/msz.PNG'
import pd from './assets/pd.png'
import Rlot from './assets/Rlot.jpg'
import width from './assets/width.png'
const Ind = () => {
    return (
        <div>
               <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={ka}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Kadane’s Algorithm</p>
      <NavLink to='/category/Flikart Interview question 1'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={knap} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>0 – 1 Knapsack Problem</p>
      <NavLink to='/category/Flikart Interview question 2'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={ioa} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Inversion of array</p>
        <NavLink to='/category/Flikart Interview question 3'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={c1na} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Consecutive 1’s not allowed</p>
      <NavLink to='/category/Flikart Interview question 4'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={mid} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Finding middle element in a linked list</p>
      <NavLink to='/category/Flikart Interview question 5'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={stkMin} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Get minimum element from stack</p>
      <NavLink to='/category/Flikart Interview question 6'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={lvbt} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Left View of Binary Tree</p>
        <NavLink to='/category/Flikart Interview question 7'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={add} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Add two numbers represented by linked lists</p>
      <NavLink to='/category/Flikart Interview question 8'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
 
  
    <div class="card 4">
    <div class="card_image">
      <img src={cnsl} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Connect Nodes at Same Level</p>
      <NavLink to='/category/Flikart Interview question 9'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={Dependency} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Sum of dependencies in a graph</p>
        <NavLink to='/category/Flikart Interview question 10'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={msz} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Maximum of all subarrays of size k</p>
      <NavLink to='/category/Flikart Interview question 11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={pd} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Possible words from Phone digits</p>
      <NavLink to='/category/Flikart Interview question 12'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={Rlot} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Reverse Level Order Traversal</p>
      <NavLink to='/category/Flikart Interview question 13'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={qus} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Implement Queue using Stack</p>
        <NavLink to='/category/Flikart Interview question 14'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={width} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Maximum Width of Tree</p>
      <NavLink to='/category/Flikart Interview question 15'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
      
    
   
    </div>
      
    )
}

export default Ind
